import * as React from "react";

import { createStyles, withStyles, WithStyles } from "@material-ui/core";

import { RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "row",
            flexGrow: 1,
        },
        left: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "66%",
        },
        right: {
            flexGrow: 0,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
        },
    });

interface Props extends WithStyles<typeof styles> {
    left?: React.ReactNode;
    right?: React.ReactNode;
}

export const PageHeaderActions = withStyles(styles, {
    name: "PageHeaderActions",
})((props: Props) => {
    const { classes, left, right } = props;

    return (
        <div className={classes.root}>
            <div className={classes.left}>{left}</div>
            <div className={classes.right}>{right}</div>
        </div>
    );
});
